import Seo from "../components/Seo";
import Header from "../components/tscm/Header";
import Footer from "../components/tscm/Footer";
import HowItRuns from "../components/tscm/HowItRuns";
import InspectionDiagram from "../components/tscm/InspectionDiagram";
import EquipmentMethod from "../components/tscm/EquipmentMethod";
import ReportingStrip from "../components/tscm/ReportingStrip";
import Confidentiality from "../components/tscm/Confidentiality";
import Contact from "../components/tscm/Contact";
import { Eyebrow, Reveal } from "../components/tscm/Reveal";
import { Breadcrumb } from "./SubpageBlocks";

const LD = [
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "Home", item: "https://tscmservices.in/" },
      { "@type": "ListItem", position: 2, name: "How we work", item: "https://tscmservices.in/how-we-work" },
    ],
  },
];

export default function HowWeWork() {
  return (
    <div id="top" className="min-h-screen bg-base-color font-body text-ink antialiased">
      <Seo
        title="How We Work — Method, Equipment and the Written Report | TSCM Services"
        description="What happens on the day of a TSCM inspection, what instruments we use, and what you receive. By Law Abiding Technology (LAT)."
        path="/how-we-work"
        jsonLd={LD}
      />
      <Header />
      <main>
        <div className="site-x pt-6">
          <Breadcrumb current="How we work" />
        </div>
        <section className="site-x pb-4 pt-10 sm:pt-14" data-testid="how-we-work-hero">
          <Reveal>
            <Eyebrow>Process, equipment and the report</Eyebrow>
            <h1 className="mt-4 max-w-2xl font-head font-extrabold tracking-tight h-hero">
              How we work.
            </h1>
            <p className="mt-5 max-w-2xl text-base leading-relaxed text-sub">
              What happens on the day, what we use, and what you receive.
            </p>
          </Reveal>
        </section>
        <HowItRuns />
        <InspectionDiagram />
        <EquipmentMethod />
        <ReportingStrip />
        <Confidentiality />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
